import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Response } from '@angular/http';
import { SignalsDciiHeadend } from '../signals';
import { ConfigService } from '../../../core/config.service';
import { HttpClient } from '../../../core/http/http-client';
import { LoggerService } from '../../../core/logger/logger.service';

@Injectable()
export class DciiGridService {
	private url = this.configService.baseUrl + '/api/DCII/';

	constructor(private configService: ConfigService,
	            private http: HttpClient,
	            private logger: LoggerService) {
	}

	getDciiGrid(): Observable<SignalsDciiHeadend[]> {
		return this.http.get(this.url)
            .map((res: Response) => {
				return res.json();
			}).catch((err) => {
				this.logger.error(err);
				return Observable.of(null);
			});
	}

	getDciiGridFiltered(filter: string): Promise<SignalsDciiHeadend[]> {
		let reqUrl = filter ? this.url + '?' + filter : this.url;
		return this.http.get(reqUrl)
            .map((res: Response) => {
				return res.json();
			}).catch((err) => {
				this.logger.error(err);
				return Observable.of(null);
			}).toPromise();
	}
}
